module.exports = __webpack_public_path__ + "img/581-b33ff5.png";